import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvoiceData {
  invoiceId: number;
  userId: string;
  adminUserId: string | null;
  documentUrl: string;
  documentOwner: string | null;
  type: string | null;
  invoiceDate: string;
  supplier: string;
  extractedPoNumber: string | null;
  documentReference: string;
  dueDate: string | null;
  category: string | null;
  productOrService: string | null;
  customer: string | null;
  markAsRebillable: string | null;

  description: string | null;
  amount: number | null;
  currency: string;
  totalAmount: number;
  taxAmount: number;
  netAmount: number | null;
  payment: string | null;
  paid: string | null;
  paymentMethod: string | null;
  lineItems: any[]; // You can further specify the structure of line items if needed
  stageId: number;
  isActive: boolean;
  isDelete: boolean;
}
interface SelectedInvoiceState {
  selectedInvoiceData: InvoiceData[]; // Array of objects, each representing a key-value pair of invoice data
}
const dummyInvoiceData: InvoiceData = {
  invoiceId: 0,
  userId: "",
  adminUserId: "",
  documentUrl: "",
  documentOwner: "",
  type: "",
  invoiceDate: "2024-11-01",
  supplier: "Supplier ABC",
  extractedPoNumber: "PO-987654",
  documentReference: "INV-12345-2024",
  dueDate: "2024-11-30",
  category: "Electronics",
  productOrService: "Laptop",
  customer: "Customer XYZ",
  markAsRebillable: "yes",
  description: "Invoice for a laptop purchase",
  amount: 1500.0,
  currency: "USD",
  totalAmount: 1800.0,
  taxAmount: 300.0,
  netAmount: 1500.0,
  payment: "Credit Card",
  paid: "",
  paymentMethod: "Visa",
  lineItems: [
    {
      itemId: 1,
      product: "Laptop",
      quantity: 1,
      unitPrice: 1500.0,
      totalPrice: 1500.0,
    },
    {
      itemId: 2,
      product: "Laptop Bag",
      quantity: 1,
      unitPrice: 50.0,
      totalPrice: 50.0,
    },
  ],
  stageId: 2, // Example: 2 could represent a stage like "Pending Approval"
  isActive: true,
  isDelete: false,
};
const initialState = { selectedInvoiceData: dummyInvoiceData };
const SelectedInvoiceReducer = createSlice({
  name: "selectedInvoice",
  initialState,
  reducers: {
    setSelectedInvoiceData(state, action: PayloadAction<any>) {
      state.selectedInvoiceData = action.payload;
    },
    resetSelectedInvoiceData(state) {
      //state.selectedInvoiceData = initialState;
      state.selectedInvoiceData = initialState.selectedInvoiceData;
    },
  },
});

export const { setSelectedInvoiceData, resetSelectedInvoiceData } =
  SelectedInvoiceReducer.actions;

export default SelectedInvoiceReducer.reducer;
